var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 49.099,
    height: 52.414,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1945",
    "data-name": "Groupe 1945",
    transform: "translate(-188 -8631)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(188 8631)",
    fill: "#d4b993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1937",
    "data-name": "Groupe 1937",
    transform: "translate(216.451 8654.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1934",
    "data-name": "Groupe 1934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1933",
    "data-name": "Groupe 1933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_728",
    "data-name": "Trac\\xE9 728",
    d: "M93.987,14.368a21.457,21.457,0,0,1-3.719-.3l-.652-.124-.063-.627C89.527,13.06,88.967,6.895,93.574,3,97.087.031,102.55-.739,109.813.711l.852.17-.155.811a14.556,14.556,0,0,1-6.344,10,19,19,0,0,1-10.179,2.676m-2.672-1.861c1.93.23,7.5.582,11.855-2.226a12.656,12.656,0,0,0,5.4-8.076c-6.227-1.107-10.864-.418-13.794,2.05-3.13,2.637-3.461,6.682-3.463,8.251",
    transform: "translate(-77.181 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_729",
    "data-name": "Trac\\xE9 729",
    d: "M79.151,47.012a.879.879,0,0,1-.89-.761,16.8,16.8,0,0,1,1.327-7.706c1.58-3.694,5.294-8.434,14.015-10.036a.9.9,0,0,1,1.05.671.852.852,0,0,1-.709.994c-6.339,1.165-10.6,4.174-12.669,8.945a15.441,15.441,0,0,0-1.232,6.96.862.862,0,0,1-.8.928q-.046,0-.091,0",
    transform: "translate(-67.438 -24.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_730",
    "data-name": "Trac\\xE9 730",
    d: "M11.677,39.307A10.73,10.73,0,0,1,4.841,37c-1.989-1.717-3-4.256-3-7.545v-.822l.868-.026c3.474-.1,6.156.78,7.974,2.627a9.738,9.738,0,0,1,2.438,7.3l-.074.695-.734.064c-.039,0-.269.022-.638.022m.555-.867h0Zm0,0h0ZM3.661,30.3a7.5,7.5,0,0,0,2.376,5.435,8.779,8.779,0,0,0,5.32,1.87,7.8,7.8,0,0,0-1.991-5.225A8.039,8.039,0,0,0,3.661,30.3",
    transform: "translate(-1.589 -24.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_731",
    "data-name": "Trac\\xE9 731",
    d: "M48.2,189.262H.9a.873.873,0,0,1-.9-.848V174.7a.843.843,0,0,1,.463-.743l7.671-4V158.237a.873.873,0,0,1,.9-.848h5.9a.873.873,0,0,1,.9.848v7.7l9.6-5.013a.939.939,0,0,1,.888.012.84.84,0,0,1,.44.73v4.4l9.842-5.139a.939.939,0,0,1,.888.012.84.84,0,0,1,.44.73v4.4l9.842-5.139a.939.939,0,0,1,.888.012.84.84,0,0,1,.44.73v26.75a.873.873,0,0,1-.9.848m-46.411-1.7H47.307V163.1l-9.842,5.139a.94.94,0,0,1-.888-.013.84.84,0,0,1-.44-.73v-4.4l-9.842,5.139a.94.94,0,0,1-.888-.013.841.841,0,0,1-.44-.73v-4.4l-9.6,5.013a.94.94,0,0,1-.888-.013.84.84,0,0,1-.44-.73v-8.285H9.926v11.367a.842.842,0,0,1-.463.743L1.792,175.2Z",
    transform: "translate(0 -136.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_732",
    "data-name": "Trac\\xE9 732",
    d: "M181.168,284.241a.873.873,0,0,1-.9-.848V277.8a.9.9,0,0,1,1.792,0v5.591a.873.873,0,0,1-.9.848",
    transform: "translate(-155.427 -240.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_733",
    "data-name": "Trac\\xE9 733",
    d: "M231.517,284.241a.873.873,0,0,1-.9-.848V277.8a.9.9,0,0,1,1.792,0v5.591a.873.873,0,0,1-.9.848",
    transform: "translate(-198.837 -240.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_734",
    "data-name": "Trac\\xE9 734",
    d: "M278.488,284.241a.873.873,0,0,1-.9-.848V277.8a.9.9,0,0,1,1.792,0v5.591a.873.873,0,0,1-.9.848",
    transform: "translate(-239.334 -240.807)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsine);
export default __webpack_public_path__ + "static/media/usine.04e06010f661a6af7cf16fa71d28b6bd.svg";
export { ForwardRef as ReactComponent };